var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketAuction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.361,
    height: 13.876,
    viewBox: "0 0 15.361 13.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10833",
    "data-name": "Group 10833",
    transform: "translate(0.431 0.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M1331.646,485.794l-.364-.521a.636.636,0,0,0-.885-.156l-2.6,1.822a.635.635,0,0,0-.156.885l.364.521.7-.1.364.52-.52.364,1.457,2.082.521-.364.365.521-.338.624.182.26a.635.635,0,0,0,.885.156l2.6-1.822a.635.635,0,0,0,.156-.885l-.182-.26-.7.1-.364-.52.521-.365-1.458-2.082-.52.364-.364-.52Z",
    transform: "translate(-1322.037 -485.003)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_631",
    "data-name": "Line 631",
    y1: 0.911,
    x2: 1.301,
    transform: "translate(7.033 2.847)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_632",
    "data-name": "Line 632",
    y1: 0.547,
    x2: 0.781,
    transform: "translate(8.854 1.936)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_633",
    "data-name": "Line 633",
    y1: 0.911,
    x2: 1.301,
    transform: "translate(8.491 4.929)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_634",
    "data-name": "Line 634",
    y1: 0.547,
    x2: 0.781,
    transform: "translate(10.312 4.018)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M1318.039,500.361l-.262.18a1.6,1.6,0,0,1-.524.246,5.04,5.04,0,0,0-1.738.954c-1.4,1.11-3.392,2.764-3.721,2.993a.953.953,0,0,1-1.093-1.561c.328-.23,2.565-1.54,4.085-2.473a5.04,5.04,0,0,0,1.491-1.307,1.6,1.6,0,0,1,.41-.408l.258-.185",
    transform: "translate(-1310.251 -494.417)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M1345.251,517.163h.953a.317.317,0,0,1,.318.318v.953",
    transform: "translate(-1334.133 -506.947)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M1332.251,518.434v-.953a.318.318,0,0,1,.318-.318h2.859",
    transform: "translate(-1325.263 -506.947)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M1334.063,521.163h-3.494a.318.318,0,0,0-.318.318v1.271h6.67v-1.271a.317.317,0,0,0-.318-.318h-1.588",
    transform: "translate(-1323.898 -509.677)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_635",
    "data-name": "Line 635",
    y2: 1.271,
    transform: "translate(12.071 7.357)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_636",
    "data-name": "Line 636",
    x1: 0.635,
    y2: 1.1,
    transform: "translate(12.865 7.74)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_637",
    "data-name": "Line 637",
    x1: 1.1,
    y2: 0.635,
    transform: "translate(13.446 8.786)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_638",
    "data-name": "Line 638",
    x1: 1.271,
    transform: "translate(13.659 10.216)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketAuction);
export default __webpack_public_path__ + "static/media/ticketAuction.6a3aefa39a3e06522dcd75a9ad309b2a.svg";
export { ForwardRef as ReactComponent };